import React from 'react'
import {Button, Form, InputNumber, Result, Space} from "antd"
import {useClubTableBookSettingContext} from "../store/useClubTableBookSettingContext"

const BookSettingRefund = () => {
    const {form, isShowReserve} = useClubTableBookSettingContext()

    return (
        <div>
            {isShowReserve ? <Form
                form={form}
            >
                <Form.List name={"cancelFee"}>
                    {(fields, {add, remove}) => (
                        <div>
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    style={{
                                        width: '40%',
                                    }}
                                >
                                    添加阶梯
                                </Button>
                            </Form.Item>
                            {fields.map((key, name, ...restField) => (
                                <Space
                                    key={key}
                                    style={{display: 'flex', marginBottom: 8}}
                                    align="baseline"
                                >
                                    <Form.Item
                                        {...restField}
                                        label={"预订时间开始前"}
                                        name={[name, 'duration']}
                                        rules={isShowReserve ? [{required: true, message: '请输入时间'}] : []}
                                    >
                                        <InputNumber controls={false}
                                                     addonAfter={"分钟"}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        label={"退款"}
                                        name={[name, 'ratio']}
                                        rules={isShowReserve ? [{required: true, message: '请输入退款比例'}] : []}
                                    >
                                        <InputNumber controls={false} addonBefore={"退款"} addonAfter={"%"}/>
                                    </Form.Item>
                                    <Form.Item>
                                        {fields.length ? (
                                            <Button onClick={() => remove(name)} type="dashed">
                                                删除
                                            </Button>
                                        ) : null}
                                    </Form.Item>
                                </Space>
                            ))}

                        </div>
                    )}
                </Form.List>

            </Form> : <Result status={"info"} subTitle={"暂未开启预定，开启可以编写"}></Result>}
        </div>
    )
}

export default BookSettingRefund


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettings/component/BookSettingRefund.js